/**
 * Serializes SplatBuffers to an INRIA-style gaussian splat PLY file
 * (binary little endian) that any standard splat tool can read.
 */

import { SplatBuffers } from './types';

// property order follows the INRIA reference implementation
const PROPERTIES = [
    'x', 'y', 'z',
    'f_dc_0', 'f_dc_1', 'f_dc_2',
    'opacity',
    'scale_0', 'scale_1', 'scale_2',
    'rot_0', 'rot_1', 'rot_2', 'rot_3'
] as const;

const writePly = (buffers: SplatBuffers): Uint8Array => {
    const { count } = buffers;

    const header = [
        'ply',
        'format binary_little_endian 1.0',
        'comment generated by supersplat shape generator',
        `element vertex ${count}`,
        ...PROPERTIES.map(name => `property float ${name}`),
        'end_header',
        ''
    ].join('\n');

    const headerBytes = new TextEncoder().encode(header);
    const bytes = new Uint8Array(headerBytes.length + count * PROPERTIES.length * 4);
    bytes.set(headerBytes, 0);

    const view = new DataView(bytes.buffer, headerBytes.length);
    for (let i = 0; i < count; i++) {
        const base = i * PROPERTIES.length * 4;
        for (let p = 0; p < PROPERTIES.length; p++) {
            view.setFloat32(base + p * 4, buffers[PROPERTIES[p]][i], true);
        }
    }

    return bytes;
};

export { writePly, PROPERTIES };
